import { CheckboxList } from "components/CheckboxList";
import React from "react";
import { useTags } from "./hooks";

interface Props {
  mainArea: server.dto.MainAreas
  value: server.dto.TagSmall[]
  onChange: (tags: server.dto.TagSmall[]) => void
  inPageEditing: "new" | "edit" | "none"
}

const TagsSelect = (props: Props) => {
  const tagsQuery = useTags(props.mainArea);

  const onChange = (selected: server.dto.TagSmall[]) => {
    props.onChange([...selected].sort((a, b) => a.tagId - b.tagId));
  };

  return <CheckboxList
    options={tagsQuery.data ?? []}
    getId={tag => tag.tagId}
    getLabel={tag => tag.title}
    value={props.value}
    onChange={onChange}
    multipleColumns={true}
    inPageEditing={props.inPageEditing}
    keyboardNavigationGroup="tagSelect"
    isLoading={tagsQuery.isLoading}
  />;
};

export default TagsSelect;
